// extracted by mini-css-extract-plugin
module.exports = {"content":"ReportFormSuperCase_index_content__1jUBN","video":"ReportFormSuperCase_index_video__2OAua","routeLink":"ReportFormSuperCase_index_routeLink__d-tQ_"};